<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <span v-else>
      <el-row>
        <p>Which disciple do you want to change to growing/commissioned?</p>
        <el-select
          class="col-md-8 select-default"
          filterable
          clearable
          v-model="discipleRecordToBeChanged"
          value-key="id"
          placeholder="Select disciple..."
        >
          <el-option
            v-for="item in growingAndCommissionedDisciples"
            :key="item.id"
            :label="item.name"
            :value="item"
          />
        </el-select>
      </el-row>
      <br>
      <div v-if="discipleRecordToBeChanged" class="text-center">
        <el-radio v-model="discipleRecordToBeChanged.disciple_type" label="Growing Disciple" />
        <el-radio v-model="discipleRecordToBeChanged.disciple_type" label="Commissioned Disciple" />
        <p class="note">
          *Marking a disciple as Commissioned will send the disciple an
          email invite to login and begin using Acts.
        </p>
      </div>
    </span>
    <p v-if="validationError === true" style="color: red;">
      A disciple and disciple type are required.
    </p>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Change Disciple Type
      </p-button>
      <p-button type="danger" v-if="saving">
        Saving...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import Modal from '../UIComponents/Modal';

import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DisciplesRepository = RepositoryFactory.get('disciples');

export default {
    name: 'ChangeDiscipleTypeModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            validationError: false,
            growingAndCommissionedDisciples: [],
            discipleRecordToBeChanged: null,
            error: '',
            saving: false
        };
    },
    computed: {

    },
    methods: {
        handleSave() {
            this.saving = true;
            if (!this.discipleRecordToBeChanged) {
                this.validationError = true;
                this.saving = false;
                return;
            }
            DisciplesRepository.updateDiscipleType(
                this.discipleRecordToBeChanged.id,
                this.discipleRecordToBeChanged.disciple_type
            )
                .then((response) => {
                    this.saving = false;
                    this.$emit('discipleChange');
                })
                .catch((error) => {
                    this.saving = false;
                    this.$message(error.response.data.message);
                });

            this.$message('Updating Disciple.');
            this.$emit('save', this.title);
            this.$emit('close');

            this.discipleRecordToBeChanged = null;
            this.validationError = false;
        },
        handleClose() {
            this.discipleRecordToBeChanged = null;
            this.validationError = false;
            this.$emit('close');
        },
        getGrowingAndCommissionedDisciplesList() {
            DisciplesRepository.getGrowingAndCommissionedDisciplesList()
                .then((response) => {
                    this.growingAndCommissionedDisciples = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        }
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getGrowingAndCommissionedDisciplesList();
            }
        }
    },
    created() {
    }

};
</script>
